import { z } from 'zod/v3';

import {
  invoicesFiltersSchema,
  invoicesSearchParamsSchema,
} from 'features/procurement/finance/InventoryInvoicesView/types';

const invoiceDetailsModalsSchema = z.object({
  vendorCodeForUpdate: z.string().optional(),
  venueIdForUpdate: z.string().optional(),
  exportToErpModalOpen: z.boolean().optional(),
  restoreModalOpen: z.boolean().optional(),
  cancelModalOpen: z.boolean().optional(),
  sendBackModalOpen: z.boolean().optional(),
  changeToNegativeModalOpen: z.boolean().optional(),
  threeWayModalOpen: z.boolean().optional(),
});

const invoiceVarianceToolbarSchema = z.object({
  varianceToolbarOpen: z.boolean().optional(),
});

export type InvoiceDetailsTabId = 'invoice-items' | 'purchase-orders';

const invoiceItemsFiltersSchema = z.object({
  itemsQ: z.coerce.string().optional(),
  quantityVariance: z.boolean().optional(),
  costVariance: z.boolean().optional(),
  varianceWarning: z.boolean().optional(),
  missingGlAccount: z.boolean().optional(),
  abnormalValues: z.boolean().optional(),
  showDetails: z.boolean().optional(),
});

export const invoiceDetailsRouteSearchSchema = z.object({
  ...invoicesFiltersSchema.shape,
  ...invoicesSearchParamsSchema.shape,
  ...invoiceItemsFiltersSchema.shape,
  ...invoiceDetailsModalsSchema.shape,
  ...invoiceVarianceToolbarSchema.shape,
  activeTabId: z.custom<InvoiceDetailsTabId>().optional(),
});

export type InvoiceItemsFilters = z.infer<typeof invoiceItemsFiltersSchema>;

export type InvoiceDetailsRouteSearch = z.infer<typeof invoiceDetailsRouteSearchSchema>;

export type InvoiceDetailsModals = z.infer<typeof invoiceDetailsModalsSchema>;
